import React, {Component} from 'react';
import {withRouter} from 'react-router-dom';
import styles from './OrderConfirmationView.module.css';
import CustomButton from '../CustomButton';
import {projectConfig} from '../../../../shared/project-info/projectConfig';
import {paymentConfig} from '../../../../shared/project-info/paymentConfig';
import moment from 'moment';
const getMembershipExpireDate = () => {
  return moment().add(184, 'days').format('MM/DD/YYYY');
};
export class OrderConfirmationView extends Component {
  constructor(props) {
    super(props);
  }
  navigateToFeed = () => {
    this.props.history.push('/feed');
  };
  render() {
    const {title, price, receiptEmail} = this.props.location?.state;
    return (
      <div className={styles.container}>
        <div className={styles.headerContainer}>
          <h3 className="title">Supporting Donation</h3>
        </div>
        <div className={styles.contentContainer}>
          <div className={[styles.centerDiv]}>
            <h2 className={[styles.titleDiv]}>{title}</h2>
            <p className={[styles.paymentDiv]}>{`${
              paymentConfig.membershipValidityText
            } ${getMembershipExpireDate()}`}</p>
            <p className={[styles.paymentRow]}>
              <strong>{`$${price}`}</strong>
            </p>
            <div className={[styles.orderCompleteSection]}>
              <div className={[styles.centerDiv]}>
                <strong>Your order is complete!</strong>
              </div>
              <p className={[styles.confirmationText]}>
                A receipt has been sent to <span>{receiptEmail}</span> with the
                confirmation number. if you have any issue please contact us at{' '}
                <span>{projectConfig.supportEmail}</span>
              </p>
            </div>
          </div>

          <div className={styles.buttonContainer}>
            <CustomButton
              onClick={() => {
                this.navigateToFeed();
              }}
              label="Done"
              buttonStyle="primary"
              // to={'/feed'}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(OrderConfirmationView);
